import React from 'react';
import { AppBar, Toolbar, Box, Typography, Avatar, Button, Menu, MenuItem, ListItemIcon } from '@mui/material';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
//import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import './Navbar.css';
import { getUserInitials } from '../utils/userInfo';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleProfile = () => {
    handleMenuClose();
    navigate('/profile');
  };
  // const handleSettings = () => {
  //   handleMenuClose();
  //   navigate('/settings');
  // };
  const handleLogout = () => {
    handleMenuClose();
    try { localStorage.removeItem('userToken'); } catch {}
    navigate('/');
  };
  // Always get latest initials from localStorage
  const initials = getUserInitials();
  return (
    <AppBar
      position="fixed"
      elevation={2}
      sx={{
        zIndex: 1201,
        borderRadius: 0,
        backgroundColor: 'white',
        color: '#222',
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', minHeight: 64 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            component="img"
            src="/kyc-logo.png"
            alt="KYC Logo"
            sx={{ width: 56, height: 36, objectFit: 'contain', borderRadius: 1, mr: 1, bgcolor: 'white' }}
          />
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, letterSpacing: 1, color: '#222', fontFamily: 'Roboto, sans-serif' }}
          >
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button
            component={RouterLink}
            to="/home"
            color={location.pathname === '/home' ? 'primary' : 'inherit'}
            className={`navbar-menu-btn${location.pathname === '/home' ? ' navbar-menu-btn-active' : ''}`}
          >
            Home
          </Button>
          {/* <Button
            component={RouterLink}
            to="/settings"
            color={location.pathname === '/settings' ? 'primary' : 'inherit'}
            className={`navbar-menu-btn${location.pathname === '/settings' ? ' navbar-menu-btn-active' : ''}`}
          >
            Settings
          </Button> */}
          <Button
            component={RouterLink}
            to="/colleagues"
            color={location.pathname === '/colleagues' ? 'primary' : 'inherit'}
            className={`navbar-menu-btn${location.pathname === '/colleagues' ? ' navbar-menu-btn-active' : ''}`}
          >
            Colleagues
          </Button>
          <Button
            component={RouterLink}
            to="/blog"
            color={location.pathname === '/blog' ? 'primary' : 'inherit'}
            className={`navbar-menu-btn${location.pathname === '/blog' ? ' navbar-menu-btn-active' : ''}`}
          >
            AiroNotes
          </Button>
          <Button
            component={RouterLink}
            to="/admin"
            color={location.pathname === '/admin' ? 'primary' : 'inherit'}
            className={`navbar-menu-btn${location.pathname === '/admin' ? ' navbar-menu-btn-active' : ''}`}
          >
            Admin
          </Button>
          <Avatar
            sx={{ bgcolor: '#FF0000', width: 36, height: 36, fontSize: '1rem', cursor: 'pointer' }}
            onClick={handleAvatarClick}
          >
            {initials}
          </Avatar>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={handleProfile}>
              <ListItemIcon>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              Profile
            </MenuItem>
            {/* <MenuItem onClick={handleSettings}>
              <ListItemIcon>
                <SettingsIcon fontSize="small" />
              </ListItemIcon>
              Settings
            </MenuItem> */}
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
